// switch input type "password" to "text" to reveal password

const passwordRevealAll = document.querySelectorAll("._jsPasswordReveal");

passwordRevealAll.forEach(passwordReveal => {
	passwordReveal.addEventListener("click", function() {
		const passwordInput = this.previousElementSibling;
		if (passwordInput.getAttribute("type") === "password") {
			passwordInput.setAttribute("type", "text");
		}
		else {
			passwordInput.setAttribute("type", "password");
		}
	});
});